module.exports = __webpack_public_path__ + "img/bank-generate-rules.0d02e438.svg";